import ActivationStatusPage from "../../pages/auth/ActivationStatusPage";
import Signin from "../common/Signin";

const LoginLayout = () => {
  return (
    <div style={{ display: "flex", alignItems: "center", height: "100%" }}>
        <ActivationStatusPage />
    </div>
  );
};

export default LoginLayout;